import React from "react";
import { Navigate, useLocation, useParams } from "react-router";
import Error404Page from "@/src/containers/Pages/Generic/Error404/Error404Page";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import { getCaseLink, getProductData, getProductNameBy } from "@/src/services/productService";
import CalendlyBookingWidget from "./CalendlyBookingWidget";
import { getAppointmentDisplayType } from "@/src/services/serviceWorldService";
import CalendlyLimitReached from "./CalendlyLimitReached";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import useProductParams from "@/src/hooks/useProductParams";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";

const Calendly = () => {
  const { responsibleParty, appointmentType } = useParams();
  const { productName, productId } = useProductParams();
  const { customer } = useCustomer();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");
  const { data: product, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId),
  });
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);

  if (!responsibleParty || !appointmentType || !productName || !productId) {
    return <Error404Page />;
  }

  if (!customer || isLoading) {
    return <LegalbirdLoader />;
  }

  switch (getAppointmentDisplayType(product)) {
    case "appointments":
      return <Navigate to={getCaseLink(product)} />;
    case "bookingWidget":
      return (
        <CalendlyBookingWidget
          customer={customer}
          product={product}
          appointmentType={appointmentType}
          responsibleParty={responsibleParty}
          utmSource={urlSearchParams.get("utm_source") || ""}
        />
      );
    case "limitReached":
    default:
      return <CalendlyLimitReached product={product} />;
  }
};

export default Calendly;
